import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { LocalScheme } from '~auth/runtime'
import { Oauth2Scheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/account/login",
    "logout": "/",
    "home": "/account/dashboard",
    "callback": "/account/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": false,
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "local"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new LocalScheme($auth, {
  "token": {
    "property": "access_token",
    "global": true
  },
  "user": {
    "property": "data",
    "autoFetch": true
  },
  "endpoints": {
    "login": {
      "url": "/auth/login",
      "method": "post"
    },
    "logout": {
      "url": "/auth/logout",
      "method": "post"
    },
    "user": {
      "url": "/auth/user",
      "method": "get"
    }
  },
  "name": "local"
}))

  // google
  $auth.registerStrategy('google', new Oauth2Scheme($auth, {
  "clientId": "474253705110-4jbn5rlobdknirq63408unsaa9ed49b2.apps.googleusercontent.com",
  "codeChallengeMethod": "",
  "responseType": "token id_token",
  "token": {
    "property": "null"
  },
  "user": {
    "autoFetch": false
  },
  "name": "google",
  "endpoints": {
    "authorization": "https://accounts.google.com/o/oauth2/auth",
    "userInfo": "https://www.googleapis.com/oauth2/v3/userinfo"
  },
  "scope": [
    "openid",
    "profile",
    "email"
  ]
}))

  // facebook
  $auth.registerStrategy('facebook', new Oauth2Scheme($auth, {
  "clientId": "",
  "token": {
    "property": null
  },
  "user": {
    "autoFetch": false
  },
  "name": "facebook",
  "endpoints": {
    "authorization": "https://facebook.com/v2.12/dialog/oauth",
    "userInfo": "https://graph.facebook.com/v2.12/me?fields=about,name,picture{url},email"
  },
  "scope": [
    "public_profile",
    "email"
  ]
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
